// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileModal_root__xENs1"};